import { useMutation, useQueryClient } from '@tanstack/react-query';
import toast from 'react-hot-toast';
import { useTranslation } from 'react-i18next';

import { destinationsApi } from '../../api/lib/destinations';
import { destinationsKeys } from '../../api/query-keys/destinations';

import { ApiError } from '@/types/interfaces/api-error';

export const useRemoveDestination = (onSuccess?: () => void) => {
  const { t } = useTranslation(['common']);
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (id: number) => destinationsApi.deleteDestination(id),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: destinationsKeys.all,
      });
      onSuccess?.();
      toast.success(t('common:popup.success'));
    },
    onError: (error: ApiError) => {
      toast.error(error?.response?.data?.message);
    },
  });
};
